import { useCollections } from 'medusa-react'
import Link from 'next/link'
import BHSocials from '@modules/account/components/socials'
import logoRectWhite from '/public/images/logo-rect-white.png'
import Image from 'next/image'
import BHRequireAccount from '@modules/account/components/require-account'
import { bhEnv } from '@lib/env'

const FooterNav = () => {
  const socialIconSize = 28

  return (
    <div className="w-full bg-blue-black text-blue-white">
      <div className="content-container flex flex-col gap-y-8 pt-16 pb-8">
        <div className="flex flex-col gap-y-6 xsmall:flex-row items-start justify-between">
          <div className="flex flex-col gap-y-6 pr-8">
            <Link href={`${bhEnv.bhMarketingHome}`} >
              <a className="text-xl-semi uppercase">
                <Image
                  src={logoRectWhite}
                  layout="fixed"
                  width={224}
                  height={224 * (logoRectWhite.height / logoRectWhite.width)}
                  loading="eager"
                  priority={true}
                  quality={90}
                  objectFit="contain"
                  objectPosition="center"
                  alt="innovation from experience"
                  draggable="false"
                />
              </a>
            </Link>
          </div>
          <div className="flex flex-wrap text-small-regular grid-cols-2 gap-x-10">
            <div className="flex flex-col gap-y-2 pr-8">
              <span className="text-base-semi uppercase pt-6">Menu</span>
              <ul className="grid grid-cols-1 gap-y-2">
                <BHRequireAccount>
                  <li>
                    <Link href="/quotes">Quotes (Cap & Chase Cover)</Link>
                  </li>
                </BHRequireAccount>
                <li>
                  <a href="#">Search</a>
                </li>
                <li>
                  <Link href="/policies/refunds">Refund Policy</Link>
                </li>
                <li>
                  <Link href="/policies/shipping">Shipping Policy</Link>
                </li>
                <li>
                  <Link href="/policies/tos">Terms of Service</Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col gap-y-2 overflow-hidden sm:text-ellipsis">
              <span className="text-base-semi uppercase pt-6">
                Contact Us Today
              </span>
              <ul className="grid grid-cols-1 gap-y-2">
                <li>
                  {bhEnv.companyInfo.name}
                  <br />
                  {bhEnv.companyInfo.addressLine1}
                  <br />
                  {bhEnv.companyInfo.addressLine2}
                </li>

                <li>Phone: {bhEnv.companyInfo.phone}</li>
                <li>
                  Email:{' '}
                  <a href={`mailto:${bhEnv.companyInfo.email}`}>
                    {bhEnv.companyInfo.email}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <span className="pt-6">
            <BHSocials size={socialIconSize} />
          </span>
        </div>
        <div className="flex flex-col-reverse gap-y-4  justify-center xsmall:flex-row xsmall:items-end xsmall:justify-between">
          <span className="text-xsmall-regular text-gray-500 text-center">
            © Copyright {new Date().getFullYear()} {bhEnv.companyInfo.name}
          </span>
        </div>
      </div>
    </div>
  )
}

export default FooterNav
